export default "__VITE_ASSET__BNY8VaTd__"